import { View } from 'foundations-components/components/View';
import { getFullUrl } from 'hubspot-url-utils';
import { BaseApp } from 'marketplace-storefront-base/containers/BaseApp';
import { debug } from 'marketplace-storefront-base/utils/env';
import { getPublicRootUrl, getShortlinkUrl, getWindowLocation } from 'marketplace-storefront-base/utils/urls';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { getIsMarketplaceUrlsScreenshotUserAgent } from 'marketplace-ui-common/utils/userAgent';
import LegacyUnifiedApp from 'marketplace-unified-public-base/containers/App';
import { useEffect, useMemo, useRef, useState } from 'react';
import { isHubSpotEmail } from './isHubSpotEmail';

/**
 * This should match LAYOUT_MAX_WIDTH in AbstractPageSection
 * https://git.hubteam.com/HubSpot/foundations-components/blob/master/foundations-components/static/js/transitional/components/AbstractPageSection/AbstractPageSection.tsx#L25
 */
import { jsx as _jsx } from "react/jsx-runtime";
const NAV_MAX_WIDTH = 1280;
function getLoginUrl(location) {
  const {
    pathname,
    search
  } = location;
  return `${getFullUrl('app')}${getShortlinkUrl()}${pathname}${search}`;
}
function isHealthCheck() {
  return getWindowLocation().search.includes('_healthCheck');
}
export function PublicApp({
  history,
  publicAuth
}) {
  const [location, setLocation] = useState(history.location);
  const marketingNavLocation = useMemo(() => ({
    pathname: `${getPublicRootUrl()}${location.pathname}`,
    search: location.search
  }), [location.pathname, location.search]);
  const isUngated = useMemo(() => {
    return isHubSpotEmail((publicAuth === null || publicAuth === void 0 ? void 0 : publicAuth.email) || '') && (debug() || isHealthCheck()) || getIsMarketplaceUrlsScreenshotUserAgent();
  }, [publicAuth]);
  const useMarketingEmbedNav = useRef(isUngated && /_marketingEmbedNav=true/i.test(location.search));
  useEffect(() => {
    const unlisten = history.listen(nextLocation => {
      setLocation(nextLocation);
    });
    return () => {
      unlisten();
    };
  }, [history]);
  if (!isUngated) {
    return /*#__PURE__*/_jsx(LegacyUnifiedApp, {});
  }
  return /*#__PURE__*/_jsx(MarketingNav, {
    location: marketingNavLocation,
    loginUrl: getLoginUrl(location),
    maxWidth: NAV_MAX_WIDTH,
    useEmbeddedGlobalNav: useMarketingEmbedNav.current,
    children: /*#__PURE__*/_jsx(BaseAppWrapper, {
      useMarketingEmbedNav: useMarketingEmbedNav.current,
      children: /*#__PURE__*/_jsx(BaseApp, {
        appContext: "public",
        history: history
      })
    })
  });
}
function BaseAppWrapper({
  children,
  useMarketingEmbedNav
}) {
  if (useMarketingEmbedNav) {
    return children;
  }
  return /*#__PURE__*/_jsx(View, {
    borderColor: "border-core-subtle",
    borderStyle: "solid",
    borderWidth: "100",
    marginBlockStart: "300",
    children: children
  });
}